module.exports = __webpack_public_path__ + "img/home-banner.86a9ba00.jpg";